import React, { Component } from 'react'
import { string, number, bool, any, oneOf } from 'prop-types'
import { Button } from 'components'
import './RTableCell.css'

export class RTableCell extends Component {
    static propTypes = {
        type: oneOf(['text', 'button', 'empty']),
        value: any,
        column: string, // column key (will be passed as className just in case)
        align: oneOf(['left', 'center', 'right']),
        weight: oneOf(['light', 'normal', 'bold']),
        bgColor: oneOf(['green']),
        bottomBordered: bool,
        isHtml: bool,
        isFirstColumn: bool,
        isLastColumn: bool,
        isFirstRow: bool,
        isLastRow: bool,
        className: string,
    }
    static defaultProps = {
        type: 'text',
        align: 'left',
        weight: 'normal',
        bgColor: undefined,
        bottomBordered: false,
        isFirstColumn: true,
        isLastColumn: true,
        isFirstRow: true,
        isLastRow: true,
        className: '',
    }

    renderContent = (type, value, isHtml) => {
        if (type === 'empty') return null
        if (type === 'text' && isHtml) {
            return <span dangerouslySetInnerHTML={{ __html: value }} />
        }
        if (type === 'button') {
            return <Button color="primary" size="sm" onClick={value.action}>{value.text}</Button>
        }
        return <span>{value}</span>
    }

    render() {
        const { type, value, column, align, weight, bgColor, bottomBordered, isHtml, isFirstColumn, isLastColumn, isFirstRow, isLastRow, className, ...otherProps } = this.props
        const backgroundColor = bgColor ? `bg-${bgColor}` : undefined
        const cellPositionClasses = [{ firstColumn: isFirstColumn, lastColumn: isLastColumn, firstRow: isFirstRow, lastRow: isLastRow }]
        return (
            <div
                className={['RTableCell', column, align, weight, backgroundColor, { 'bottom-border': bottomBordered }, ...cellPositionClasses, className]}
                {...otherProps}
            >
                {this.renderContent(type, value, isHtml)}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/RTable/RTableCell/RTableCell.js